import { render, staticRenderFns } from "./people.vue?vue&type=template&id=ceff756a"
import script from "./people.vue?vue&type=script&lang=js"
export * from "./people.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports